import { type ComponentProps, type ReactNode } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { X } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxChipRemoveProps extends PartProps<ComponentProps<typeof Combobox.ChipRemove>> {
  className?: string
  icon?: ReactNode
}

function ComboboxChipRemove({ className, children, icon, ...props }: ComboboxChipRemoveProps) {
  return (
    <Combobox.ChipRemove
      className={twMerge(
        'corner-smooth ml-1 inline-flex h-4 w-4 items-center justify-center rounded-sm',
        'text-foreground-secondary transition-colors',
        'hover:bg-element-hover hover:text-foreground',
        'focus:bg-element-hover focus:text-foreground',
        className,
      )}
      {...props}
    >
      {icon || children || <X className="h-3 w-3" />}
    </Combobox.ChipRemove>
  )
}

export { ComboboxChipRemove }
